var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("dialogue", {
        attrs: {
          title: "Add Box",
          paragraph: _vm.box_dialogue_text,
          button_names: ["Yes", "No"],
          show: _vm.box_dialogue
        },
        on: { dialogue: _vm.addBox, cancel: _vm.cancelBox }
      }),
      _vm._v(" "),
      _c("checkitem", {
        attrs: { show: _vm.checkOpen, isIn: _vm.checkIsIn, itemId: _vm.term },
        on: { cancel: _vm.closeCheck, dialogue: _vm.checkItem }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("layout-2", {
            key: _vm.updateKey,
            staticStyle: { width: "100%" },
            attrs: {
              id: _vm.pageid,
              navbar: true,
              title: "Edit Inventory Item",
              use_radio: false,
              term: _vm.term,
              reroute: false
            },
            on: { save: _vm.checkItem }
          }),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "margin-left": "25px", "margin-right": "25px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { padding: "16px" } },
            [
              _c("inventorypics", {
                staticStyle: { width: "100%" },
                attrs: {
                  inventorypic_id: _vm.term,
                  imageCount: 99,
                  height: "300px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "margin-left": "25px", "margin-right": "25px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("b-form-file", {
                staticClass: "upload-box text-nowrap text-truncate",
                attrs: {
                  size: "lg",
                  state: Boolean(_vm.uploadFiles),
                  placeholder: "Choose or Drop files here",
                  "drop-placeholder": "Drop files here",
                  multiple: ""
                },
                on: {
                  input: function($event) {
                    return _vm.select()
                  }
                },
                model: {
                  value: _vm.uploadFiles,
                  callback: function($$v) {
                    _vm.uploadFiles = $$v
                  },
                  expression: "uploadFiles"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.uploadFiles.length > 0
                ? _c("img", {
                    staticStyle: { height: "10vh" },
                    attrs: { id: "file_upload", src: "#" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("p", { attrs: { id: "more" } }),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "margin-left": "25px", "margin-right": "25px" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "uploading-box",
                  class: { hidden: !_vm.loading }
                },
                [
                  _c("div", {
                    staticClass: "uploading-bar-green",
                    style: "width:" + _vm.loadingBarWidth + "%",
                    attrs: { id: "loading-progress" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "uploading-box",
                  class: { hidden: !_vm.uploading }
                },
                [
                  _c(
                    "div",
                    { staticClass: "uploading-bar", attrs: { id: "progress" } },
                    [
                      _c("p", {
                        staticClass: "upload-text",
                        attrs: { id: "progress-text" }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "div",
          [
            _vm._l(_vm.nav_items, function(item, index) {
              return _vm.perms.includes(_vm.nav_item_perms[index])
                ? _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.button(item)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item))]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.check(false)
                  }
                }
              },
              [_vm._v("Check Out")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.check(true)
                  }
                }
              },
              [_vm._v("Check In")]
            )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44de234d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44de234d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Inventory_Items.vue
// module id = 694
// module chunks = 0